"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Qualifier mon Offre"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="sm">
                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"}>
                    <PaveScaleCard title={<>
                        Classements,
                        Marques & Labels</>} buttonLabel={"Consulter"} className={"h-[400px]"}
                                   link="/espace-pro/office-et-vous/qualifier-mon-offre/classements-marques-labels"
                                   image={"/images/espace-pro/qualifier-mon-offre/1.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>

                    <PaveScaleCard title={<>
                        Activité de Meublé
                        de Tourisme et
                        de Chambre d'Hôtes</>} buttonLabel={"Consulter"} className={"h-[400px]"}
                                   link="/espace-pro/office-et-vous/qualifier-mon-offre/activite-meuble-tourisme-chambre-hotes"
                                   image={"/images/espace-pro/qualifier-mon-offre/2.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>
                </div>
            </SectionPage>

        </div>
    );
}
